import { createFileRoute } from '@tanstack/react-router'
import { SubscriptionShortcutPath } from 'appRoutes'
import { SubscriptionShortcutRedirect } from 'features/subscription'

export const Route = createFileRoute('/_authenticated/_layout/templates/$')({
  component: TemplatesShortcutPage,
})

function TemplatesShortcutPage() {
  const { _splat } = Route.useParams()

  if (!_splat) {
    return <SubscriptionShortcutRedirect pathname={'rulesets' as SubscriptionShortcutPath} />
  }

  return <SubscriptionShortcutRedirect pathname={`rulesets/templates/${_splat}` as SubscriptionShortcutPath} />
}
